import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Notifications from '../Notification'

export class Header extends Component {

  constructor (props) {
    super(props)

    this.logout = this.logout.bind(this)
  }

  _renderNotif (item, i) {
    return (
      <Notifications.Notification key={i}>
        <Notifications.StandardNotification />
      </Notifications.Notification>
    )
  }

  renderNotifications (notifs) {
    return notifs.map(this._renderNotif)
  }

  logout () {
    const { origin } = window.location
    this.props.logoutUser(`${origin}/callback`)
  }

  render () {
    const { userinfo } = this.props
    const notifications = this.renderNotifications(this.props.notifications)
    
    return (
      <div className="axiom-navigation-nav">
        {notifications}
        <div className="axiom-navigation-container">
          <Link to="/dashboard" className="axiom-navigation-logo" />
          <span className="axiom-navigation-productName">QA</span>
        </div>
        <div className="axiom-navigation-container">
          <Link to="/dashboard" className="axiom-navigation-activeLink">
            Projects
          </Link>
          <div className="axiom-dropdown-dropdown axiom-dropdown-transparent axiom-dropdown-hoverable">
            <button className="axiom-dropdown-dropbutton">
              <span className="axiom-dropdown-text">
                {userinfo.email}
              </span>
            </button>
            <div className="axiom-dropdown-menu">
              <ul>
                <li onClick={this.logout}>
                    <i className="axiom-icon-icon icon-log-out"></i> Log Out
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Header.defaultProps = {
  notifications: []
}
